import { useState, useEffect } from "react"

export const useIsDesktop = (): boolean => {
  const [isDesktop, setIsDesktop] = useState(false)
  useEffect(() => {
    const mediaWatcher = window.matchMedia("(min-width: 1280px)")
    setIsDesktop(mediaWatcher.matches)

    function updateIsDesktop(e) {
      setIsDesktop(e.matches)
    }

    mediaWatcher.addEventListener?.("change", updateIsDesktop)
    return () => {
      mediaWatcher.removeEventListener?.("change", updateIsDesktop)
    }
  }, [])

  return isDesktop
}
